import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

import CardCharge from '../containers/CardCharge';
import CardInput from '../containers/CardInput';
import CardSelected from '../containers/CardSelected';

const Card = props => (
  <div className="u-mt+">
    <CardSelected />
    <CardInput onToken={props.onToken} />
    <div className="u-text-center u-mt+">
      <CardCharge onCharge={props.onToken} />
    </div>
  </div>
);

Card.propTypes = {
  onToken: PropTypes.func,
};

Card.defaultProps = {
  onToken: noop,
};

export default Card;
